export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.organization': '组织架构',
  'menu.user': '用户管理',
  'menu.system': '系统管理',
  'menu.system.permission': '权限管理',
  'menu.system.role': '角色管理',
  'menu.system.tag': '标签管理',
  'menu.system.calendar': '日历管理',
  'menu.vacation': '假期管理',
  'menu.vacation.balance': '假期余额',
  'menu.vacation.leaveApplications': '请假审批',
  'menu.vacation.quota': '额度配置',
  'menu.vacation.yearlyQuota': '年度额度配置',
  'menu.vacation.expiry': '有效期列表',
  'menu.vacation.typeExpiry': '类型有效期配置',
  'menu.vacation.parentalLeaveConfig': '育儿假配置',
  'menu.vacation.parentalLeaveHistory': '育儿假发放历史',
  'menu.approval': '审批管理',
  'menu.approval.templates': '审批模板',
  'menu.approval.my': '我发起的',
  'menu.approval.applications': '审批记录',
  'menu.approval.department': '部门审批',
  'menu.approval.submit': '发起审批',
  'menu.vehicle': '公车管理',
  'menu.vehicle.applications': '公车使用记录',
  'menu.vehicle.refuelRecords': '加油记录',
  'menu.vehicle.repairApplications': '车辆维修记录',
  'menu.vehicle.managers': '车辆负责人',
  'menu.document': '发文管理',
  'menu.document.applications': '发文记录',
  'menu.document.statistics': '发文统计',
  'menu.document.numberConfig': '发文号配置',
  'menu.incomingDocument': '收文传阅',
  'menu.incomingDocument.applications': '收文记录',
  'menu.archive': '文书档案管理',
  'menu.archive.applications': '档案管理',
  'menu.archive.numberConfig': '档案编号配置',
  'menu.archive.admins': '管理员配置',
  'menu.shift': '排班管理',
  'menu.asset': '资产管理',
  'menu.contract': '合同管理',
  'menu.contract.list': '合同列表',
  'menu.contract.prefixConfig': '前缀配置',
  'menu.contract.numberConfig': '编号序列配置',
  'menu.contract.admins': '管理员配置',
  'menu.property': '不动产管理',
  'menu.property.list': '不动产列表',
  'menu.property.rentalItems': '租赁物列表',
  'menu.property.statistics': '数据统计',
  'menu.publish': '信息发布',
  'menu.publish.applications': '发布记录',
  'menu.profile': '员工档案',
  'menu.test': '测试模块',
};
